import { render, staticRenderFns } from "./EmotionalMovements.vue?vue&type=template&id=71db33b7&scoped=true"
import script from "./EmotionalMovements.vue?vue&type=script&lang=js"
export * from "./EmotionalMovements.vue?vue&type=script&lang=js"
import style0 from "./EmotionalMovements.vue?vue&type=style&index=0&id=71db33b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db33b7",
  null
  
)

export default component.exports